/* eslint-disable max-lines */
/* eslint-disable no-extra-parens */
import {
    BellIcon,
    CalendarIcon,
    CogIcon,
    HeroEllipsisVerticalIcon,
    LogoutIcon,

} from 'components/Icon'
import {
    Dropdown, DropdownButtonNew, DropdownContent,
} from 'components/Dropdown'

import {
    dropdownsButtonsWrapper,
    list,
} from '../styles'

import Button from 'components/Button'
import {Icon} from 'components/Icon/types'
import React from 'react'
import Tooltip from 'components/Tooltip'

import {closeSession} from 'api/action/closeSession'

import {navigation} from 'navigation'
import {styled} from 'stitches/config'
import {
    useAppDispatch,
} from 'hooks'
import {useTranslation} from 'react-i18next'

const StyledList = styled('ul', list)
const StyledDropdownButtonsWrapper = styled('div', dropdownsButtonsWrapper)


export const SideMenuHomeView = () => {
    const {t} = useTranslation()
    const dispatch = useAppDispatch()
    const logout = async (): Promise<void> => {
        await dispatch(closeSession())
    }

    return (
        <StyledList>
            <li>
                <Dropdown>
                    <DropdownButtonNew caret={false} color='text' iconRight={HeroEllipsisVerticalIcon as unknown as Icon} />
                    <DropdownContent direction='left' >
                        <StyledDropdownButtonsWrapper>
                            <Button color='text' iconLeft={BellIcon} onPress={(): void => { navigation.push('Home') }} text={t('Home & activity')} />
                            <Button
                                color='text'
                                iconLeft={CalendarIcon}
                                onPress={(): void => { navigation.push('ScheduledAppointments') }}
                                text={t('Scheduled appointments')}
                            />
                            <Button
                                color='text'
                                iconLeft={CogIcon}
                                onPress={(): void => { navigation.push('Settings') }}
                                text={t('User settings & profile')}
                            />
                            <Button
                                color='text'
                                iconLeft={LogoutIcon}
                                onPress={(): void => { logout() }}
                                text={t('Sign out')}
                            />
                        </StyledDropdownButtonsWrapper>
                    </DropdownContent>
                </Dropdown>
            </li>
            <li>
                <Button color='text' data-tooltip-id='home' iconLeft={BellIcon} onPress={(): void => { navigation.push('Home') }} text='' />
                <Tooltip id='home' position='right' singleLine>
                    {t('Home & activity')}
                </Tooltip>
            </li>
            <li>
                <Button color='text' data-tooltip-id='schedule' iconLeft={CalendarIcon} onPress={(): void => { navigation.push('ScheduledAppointments') }} text='' />
                <Tooltip id='schedule' position='right' singleLine>
                    {t('Scheduled appointments')}
                </Tooltip>
            </li>
            <li>
                <Button color='text' data-tooltip-id='profile' iconLeft={CogIcon} onPress={(): void => { navigation.push('Settings') }} text='' />
                <Tooltip id='profile' position='right' singleLine>
                    {t('User settings & profile')}
                </Tooltip>
            </li>
            <li>
                <Button color='text' data-tooltip-id='sign-out' iconLeft={LogoutIcon} onPress={(): void => { logout() }} text='' />
                <Tooltip id='sign-out' position='right' singleLine>
                    {t('Sign out')}
                </Tooltip>
            </li>
        </StyledList>
    )
}
